import OrdersToolbar from "./OrdersToolbar";
import OrdersFilterBar from "./OrdersFilterBar";
import OrdersActiveFilters from "./OrdersActiveFilters";
import { getActiveOrderFilters } from "./orderFilterModel";
import styles from "./OrdersToolbar.module.css";

const OrdersControls = ({
  totalOrders,
  values,
  defaults,
  handlers,
  categoryOptions,
}) => {
  const filters = getActiveOrderFilters(values, defaults);

  return (
    <div className={styles.controlsSurface}>
      <OrdersToolbar
        totalOrders={totalOrders}
        onRefresh={handlers.onRefresh}
        onCreateOrder={handlers.onCreateOrder}
      />
      <OrdersFilterBar
        values={values}
        handlers={handlers}
        categoryOptions={categoryOptions}
      />
      <OrdersActiveFilters
        filters={filters}
        onClear={handlers.onClearFilter}
        onReset={handlers.onReset}
        includeDummy={values.includeDummy}
        onToggleDummy={handlers.onToggleDummy}
      />
    </div>
  );
};

export default OrdersControls;
